import React, { useEffect, useMemo, useState } from "react";
import { getCartReportService } from "../../../services/apiService";

const PendingCartList = () => {
  const [cartData, setCartData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ Pagination states
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // ✅ Fetch Cart Report
  const fetchCartReport = async () => {
    try {
      setLoading(true);
      const res = await getCartReportService();
      setCartData(res?.data || []);
    } catch (err) {
      console.error("Cart report error:", err);
      setCartData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCartReport();
  }, []);

  // ✅ Search Filter (Customer ID + Customer Name only)
  const filteredData = useMemo(() => {
    if (!search) return cartData;

    return cartData.filter((row) => {
      const customerName = `${row.first_name || ""} ${row.last_name || ""}`
        .trim()
        .toLowerCase();

      const customerId = String(row.cartid || "").toLowerCase();

      const searchText = search.toLowerCase();

      return customerId.includes(searchText) || customerName.includes(searchText);
    });
  }, [cartData, search]);

  // ✅ Date Format Like Screenshot (Jan 20, 2026)
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };

  // ✅ Pagination calculations
  const totalPages = Math.ceil(filteredData.length / pageSize);
  const paginatedData = filteredData.slice(
    (page - 1) * pageSize,
    page * pageSize
  );

  return (
    <div style={styles.wrapper}>
      {/* Header */}
      <div style={styles.header}>
        <h2 style={styles.title}>Pending Cart-List</h2>

        <div style={styles.searchBox}>
          <span style={styles.searchIcon}>🔍</span>
          <input
            type="text"
            placeholder="Search by Customer ID / Name"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1); // ✅ reset page when searching
            }}
            style={styles.searchInput}
          />
        </div>
      </div>

      {/* Table Box */}
      <div style={styles.tableOuter}>
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr style={styles.trHead}>
                <th style={styles.th}>Cart-Id</th>
                <th style={styles.th}>Customer Name</th>
                <th style={styles.th}>Model No</th>
                <th style={styles.th}>Brand</th>
                <th style={styles.th}>Sub Category</th>
                <th style={styles.th}>Mobile</th>
                <th style={styles.th}>Date</th>
                <th style={styles.th}>Quantity</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td style={styles.noData} colSpan={8}>
                    Loading...
                  </td>
                </tr>
              ) : paginatedData.length === 0 ? (
                <tr>
                  <td style={styles.noData} colSpan={8}>
                    No Data Found
                  </td>
                </tr>
              ) : (
                paginatedData.map((row, idx) => (
                  <tr
                    key={row.cartid}
                    style={{
                      background: idx % 2 === 0 ? "#fff" : "#f2f2f2",
                    }}
                  >
                    <td style={styles.td}>{row.cartid}</td>

                    <td style={styles.td}>
                      {`${row.first_name || ""} ${row.last_name || ""}`.trim() ||
                        row.username ||
                        "-"}
                    </td>

                    <td style={styles.td}>{row.modelno}</td>
                    <td style={styles.td}>{row.brand}</td>
                    <td style={styles.td}>{row.subcategory}</td>
                    <td style={styles.td}>{row.mobile}</td>
                    <td style={styles.td}>{formatDate(row.date)}</td>
                    <td style={styles.td}>{row.qty}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* ✅ Pagination Section (same style you gave) */}
       
<div className="pagination-container">


<div>

Items per page:

<select
className="page-select"
value={pageSize}
onChange={(e) => {
setPageSize(Number(e.target.value));
setPage(1);
}}
>

{[5,10,20,50].map((n)=>(
<option key={n} value={n}>
{n}
</option>
))}

</select>

</div>



<div className="page-buttons">

<button
className="page-btn"
disabled={page===1}
onClick={()=>setPage(page-1)}
>
Previous
</button>


<span className="page-count">

{page} / {totalPages || 1}

</span>


<button
className="page-btn"
disabled={page===totalPages || totalPages===0}
onClick={()=>setPage(page+1)}
>
Next
</button>

</div>


</div>
      </div>
    </div>
  );
};

export default PendingCartList;

/* ✅ Inline Styles (same UI like screenshot) */
const styles = {
  wrapper: {
    width: "100%",
    background: "#fff",
    padding: "12px 14px",
    fontFamily: "Arial, sans-serif",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },

  title: {
    margin: 0,
    color: "#0f9d58",
    fontSize: "22px",
    fontWeight: "700",
  },

  searchBox: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ddd",
    borderRadius: "6px",
    padding: "4px 10px",
    width: "220px",
    background: "#fff",
  },

  searchIcon: {
    fontSize: "14px",
    marginRight: "6px",
    color: "#0f9d58",
  },

  searchInput: {
    border: "none",
    outline: "none",
    width: "100%",
    fontSize: "14px",
  },

  tableOuter: {
    border: "1px solid #dcdcdc",
    borderRadius: "6px",
    padding: "10px",
  },

  tableContainer: {
    overflowX: "auto",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "1000px",
  },

  trHead: {
    background: "#eeeeee",
  },

  th: {
    padding: "10px",
    fontSize: "12px",
    textAlign: "left",
    borderBottom: "1px solid #ddd",
    fontWeight: "700",
  },

  td: {
    padding: "10px",
    fontSize: "12px",
    borderBottom: "1px solid #e5e5e5",
  },

  noData: {
    padding: "14px",
    textAlign: "center",
    fontSize: "14px",
  },
};
